export function toTitleCaseSmart(input: string): string {
    const lowercaseWords = ['de', 'la', 'y', 'del', 'el', 'los', 'las', 'a', 'en', 'con', 'por', 'para', 'sin', 'al'];

    return input
      .toLowerCase()
      .split(/[-_\s]+/) // separa por guión, guión bajo o espacio
      .map((word, index) => {
        if (index === 0 || !lowercaseWords.includes(word)) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        } else {
          return word;
        }
      })
      .join(' ');
  }